import React, {useState, useEffect} from 'react'
import Header from 'components/Headers/Header'
import { Card, CardBody, CardGroup, CardHeader, CardText, CardTitle, Row,Col, Container } from 'reactstrap'
import DeviceCard from './DeviceCard';
import { automationCount, deviceList } from 'network/ApiAxiosAutomation';

function AutomationMain() {
    const [selected, setSelected] = useState(1);
    const [deviceCount, setDeviceCount] = useState();
    useEffect(() => {
        getDeviceCount
        listDevices
    }, []);
    useEffect(() => {
        listDevices
    }, [selected]);

    const getDeviceCount = async()=>{
        const resp = await automationCount()
        if(resp.data.success){
            setDeviceCount(resp.data.count)
        }
    }

    const listDevices = ()=>{
        switch (selected) {
            case 1:
                return renderDeviceCards('albufeira')
                break;
            case 2:
                return renderDeviceCards('heaven')
                break;
            case 3:
                return renderDeviceCards('tropicana')
                break;
            case 4:
                return renderDeviceCards('albufissa')
                break;
            case 5:
                return renderDeviceCards('warehouse')
                break;
            case 6:
                return renderDeviceCards('other')
                break;
        }
    }

    const renderDeviceCards = async(house)=>{
    const resp = await deviceList(house)
    if(resp.data.success){
        return resp.data.devices.map((deviceItem)=>
            {return <Col key={deviceItem._id}>
                <DeviceCard device={deviceItem}/>
            </Col>}
        )
    }else{
        return false
    }
    }
  return (<>
        <Header/>
        <Container>
            <CardGroup className='mt--4'>
                <Card className={selected == 1 ? 'mr-2 bg-primary text-white' : 'mr-2'} onClick={()=>setSelected(1)}>
                    <CardHeader className='bg-transparent'>
                        <CardTitle>Albufeira 66</CardTitle>
                    </CardHeader>
                    <CardBody>
                        <CardText>
                            Devices: {deviceCount && deviceCount.albufeira}
                        </CardText>
                    </CardBody>
                </Card>
                <Card className={selected == 2 ? 'mr-2 bg-primary text-white' : 'mr-2'} onClick={()=>setSelected(2)}>
                    <CardHeader className='bg-transparent'>
                        <CardTitle>Heaven</CardTitle>
                    </CardHeader>
                    <CardBody>
                        <CardText>
                            Devices: {deviceCount && deviceCount.heaven}
                        </CardText>
                    </CardBody>
                </Card>
                <Card className={selected == 3 ? 'mr-2 bg-primary text-white' : 'mr-2'} onClick={()=>setSelected(3)}>
                    <CardHeader className='bg-transparent'>
                        <CardTitle>Tropicana</CardTitle>
                    </CardHeader>
                    <CardBody>
                        <CardText>
                            Devices: {deviceCount && deviceCount.tropicana}
                        </CardText>
                    </CardBody>
                </Card>
                <Card className={selected == 4 ? 'mr-2 bg-primary text-white' : 'mr-2'} onClick={()=>setSelected(4)}>
                    <CardHeader className='bg-transparent'>
                        <CardTitle>Albufissa</CardTitle>
                    </CardHeader>
                    <CardBody>
                        <CardText>
                            Devices: {deviceCount && deviceCount.albufissa}
                        </CardText>
                    </CardBody>
                </Card>
                <Card className={selected == 5 ? 'mr-2 bg-primary text-white' : 'mr-2'} onClick={()=>setSelected(5)}>
                    <CardHeader className='bg-transparent'>
                        <CardTitle>Warehouse</CardTitle>
                    </CardHeader>
                    <CardBody>
                        <CardText>
                            Devices: {deviceCount && deviceCount.warehouse}
                        </CardText>
                    </CardBody>
                </Card>
                <Card className={selected == 6 ? 'mr-2 bg-primary text-white' : 'mr-2'} onClick={()=>setSelected(6)}>
                    <CardHeader className='bg-transparent'>
                        <CardTitle>Others</CardTitle>
                    </CardHeader>
                    <CardBody>
                        <CardText>
                            Devices: {deviceCount && deviceCount.other}
                        </CardText>
                    </CardBody>
                </Card>
            </CardGroup>
            
            
            <Row className='mt-4 mb-4'>
                {
                    deviceCount && listDevices()
                }
            </Row>
        </Container>
    </>
  )
}

export default AutomationMain